import angular from 'angular';
import contactInfoLink from './contactInfoLink';
import './style.scss';

export default angular
  .module('components.contactInfoLink', [])
  .component('contactInfoLink', contactInfoLink).name;
